// extracted by mini-css-extract-plugin
export default {"heading":"Section_heading__TyEG6","subtitle":"Section_subtitle__0yeCW","loading":"Section_loading__wa5IH"};